var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployeeLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#DFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1996 15.5967H22.8834C23.562 15.5967 24.129 15.1271 24.2904 14.4965H26.0904C26.7926 14.4965 27.3641 15.069 27.3641 15.7734V18.1821C27.3641 18.3744 27.5199 18.5299 27.7119 18.5299C27.9039 18.5299 28.0598 18.3744 28.0598 18.1821V15.7734C28.0598 14.6857 27.1763 13.8008 26.0904 13.8008H24.298C24.1457 13.1587 23.5711 12.6784 22.8831 12.6784H22.2124C22.0267 11.6415 21.13 10.8711 20.0413 10.8711C18.954 10.8711 18.0591 11.6415 17.8733 12.6784H17.1996C16.8159 12.6784 16.441 12.8332 16.1707 13.1034C15.8945 13.38 15.7422 13.7469 15.7422 14.1358C15.7422 14.9414 16.3958 15.5967 17.1996 15.5967ZM16.6625 13.5953C16.8031 13.4547 16.9989 13.3741 17.1992 13.3741H18.186C18.3745 13.3741 18.5286 13.2238 18.5338 13.0356C18.5564 12.212 19.2184 11.5667 20.0413 11.5667C20.866 11.5667 21.5297 12.212 21.5519 13.036C21.5571 13.2241 21.7112 13.3744 21.8998 13.3744H22.8834C23.3036 13.3744 23.6451 13.716 23.6451 14.1358C23.6451 14.5577 23.3036 14.901 22.8834 14.901H17.1996C16.7794 14.901 16.4378 14.5577 16.4378 14.1358C16.4378 13.9323 16.5175 13.7403 16.6625 13.5953Z",
    fill: "url(#paint0_linear_3381_78698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6966 17.6017C17.6966 17.4094 17.5408 17.2539 17.3488 17.2539H14.6642C14.4722 17.2539 14.3164 17.4094 14.3164 17.6017V20.2863C14.3164 20.4786 14.4722 20.6341 14.6642 20.6341H17.3488C17.5408 20.6341 17.6966 20.4786 17.6966 20.2863V17.6017ZM17.0009 19.9384H15.0121V17.9496H17.0009V19.9384Z",
    fill: "url(#paint1_linear_3381_78698)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6966 22.5002C17.6966 22.3078 17.5408 22.1523 17.3488 22.1523H14.6642C14.4722 22.1523 14.3164 22.3078 14.3164 22.5002V25.1847C14.3164 25.377 14.4722 25.5325 14.6642 25.5325H17.3488C17.5408 25.5325 17.6966 25.377 17.6966 25.1847V22.5002ZM17.0009 24.8369H15.0121V22.848H17.0009V24.8369Z",
    fill: "url(#paint2_linear_3381_78698)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3488 27.0547H14.6642C14.4722 27.0547 14.3164 27.2102 14.3164 27.4025V30.087C14.3164 30.2794 14.4722 30.4349 14.6642 30.4349H17.3488C17.5408 30.4349 17.6966 30.2794 17.6966 30.087V27.4025C17.6966 27.2105 17.5408 27.0547 17.3488 27.0547ZM17.0009 29.7392H15.0121V27.7503H17.0009V29.7392Z",
    fill: "url(#paint3_linear_3381_78698)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6734 18.1174C25.6734 17.925 25.5176 17.7695 25.3256 17.7695H19.4845C19.2925 17.7695 19.1367 17.925 19.1367 18.1174C19.1367 18.3097 19.2925 18.4652 19.4845 18.4652H25.3256C25.5179 18.4652 25.6734 18.3097 25.6734 18.1174Z",
    fill: "url(#paint4_linear_3381_78698)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9691 19.4219H19.4845C19.2925 19.4219 19.1367 19.5774 19.1367 19.7697C19.1367 19.962 19.2925 20.1175 19.4845 20.1175H22.9691C23.1611 20.1175 23.3169 19.962 23.3169 19.7697C23.3169 19.5774 23.1611 19.4219 22.9691 19.4219Z",
    fill: "url(#paint5_linear_3381_78698)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4845 23.3675H21.6167C21.8087 23.3675 21.9645 23.212 21.9645 23.0197C21.9645 22.8274 21.8087 22.6719 21.6167 22.6719H19.4845C19.2925 22.6719 19.1367 22.8274 19.1367 23.0197C19.1367 23.212 19.2925 23.3675 19.4845 23.3675Z",
    fill: "url(#paint6_linear_3381_78698)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4845 25.016H21.6167C21.8087 25.016 21.9645 24.8605 21.9645 24.6681C21.9645 24.4758 21.8087 24.3203 21.6167 24.3203H19.4845C19.2925 24.3203 19.1367 24.4758 19.1367 24.6681C19.1367 24.8605 19.2925 25.016 19.4845 25.016Z",
    fill: "url(#paint7_linear_3381_78698)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4845 28.266H22.127C22.319 28.266 22.4748 28.1105 22.4748 27.9181C22.4748 27.7258 22.319 27.5703 22.127 27.5703H19.4845C19.2925 27.5703 19.1367 27.7258 19.1367 27.9181C19.1367 28.1105 19.2925 28.266 19.4845 28.266Z",
    fill: "url(#paint8_linear_3381_78698)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4845 29.9183H25.3256C25.5176 29.9183 25.6734 29.7628 25.6734 29.5705C25.6734 29.3781 25.5176 29.2227 25.3256 29.2227H19.4845C19.2925 29.2227 19.1367 29.3781 19.1367 29.5705C19.1367 29.7628 19.2925 29.9183 19.4845 29.9183Z",
    fill: "url(#paint9_linear_3381_78698)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.974 23.9903C31.974 21.5803 30.0134 19.6199 27.6036 19.6199C25.1953 19.6199 23.236 21.5806 23.236 23.9903C23.236 26.3987 25.1953 28.3583 27.6036 28.3583C27.7066 28.3583 27.8071 28.35 27.9083 28.343C27.7344 28.4123 27.5441 28.4133 27.3633 28.3601V31.1625C27.3633 31.8651 26.7918 32.4363 26.0895 32.4363H13.9928C13.2906 32.4363 12.7191 31.8648 12.7191 31.1625V15.7733C12.7191 15.0693 13.2906 14.4964 13.9928 14.4964H14.958C15.15 14.4964 15.3059 14.341 15.3059 14.1486C15.3059 13.9563 15.15 13.8008 14.958 13.8008H13.9928C12.9069 13.8008 12.0234 14.6857 12.0234 15.7733V31.1625C12.0234 32.2484 12.9069 33.1319 13.9928 33.1319H26.0895C27.1754 33.1319 28.0589 32.2484 28.0589 31.1625V28.3343C30.2554 28.1058 31.974 26.245 31.974 23.9903ZM27.6033 27.6623C25.5786 27.6623 23.9313 26.015 23.9313 23.99C23.9313 21.9636 25.5786 20.3152 27.6033 20.3152C29.6297 20.3152 31.278 21.9636 31.278 23.99C31.2784 26.015 29.6297 27.6623 27.6033 27.6623Z",
    fill: "url(#paint10_linear_3381_78698)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6054 22.7919C27.8392 22.7919 28.0291 22.9821 28.0291 23.2159C28.0291 23.4082 28.1849 23.5637 28.3769 23.5637C28.5689 23.5637 28.7247 23.4082 28.7247 23.2159C28.7247 22.7209 28.3995 22.3046 27.9532 22.1571V22.0197C27.9532 21.8274 27.7974 21.6719 27.6054 21.6719C27.4134 21.6719 27.2576 21.8274 27.2576 22.0197V22.1567C26.8103 22.3039 26.4844 22.7202 26.4844 23.2155C26.4844 23.8336 26.9873 24.3366 27.6054 24.3366C27.8392 24.3366 28.0291 24.5268 28.0291 24.7606C28.0291 24.9943 27.8392 25.1842 27.6054 25.1842C27.371 25.1842 27.18 24.9943 27.18 24.7606C27.18 24.5682 27.0242 24.4127 26.8322 24.4127C26.6402 24.4127 26.4844 24.5682 26.4844 24.7606C26.4844 25.2559 26.8103 25.6719 27.2576 25.819V25.956C27.2576 26.1484 27.4134 26.3039 27.6054 26.3039C27.7974 26.3039 27.9532 26.1484 27.9532 25.956V25.8187C28.3995 25.6715 28.7247 25.2552 28.7247 24.7602C28.7247 24.1432 28.2225 23.6406 27.6054 23.6406C27.371 23.6406 27.18 23.4496 27.18 23.2152C27.1804 22.9821 27.371 22.7919 27.6054 22.7919Z",
    fill: "url(#paint11_linear_3381_78698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3381_78698",
    x1: 15.313,
    y1: 7.41301,
    x2: 37.3283,
    y2: 32.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3381_78698",
    x1: 9.97797,
    y1: 12.1311,
    x2: 31.9933,
    y2: 37.0108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3381_78698",
    x1: 7.54632,
    y1: 14.2814,
    x2: 29.5613,
    y2: 39.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3381_78698",
    x1: 5.11467,
    y1: 16.4359,
    x2: 27.1296,
    y2: 41.3152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3381_78698",
    x1: 13.976,
    y1: 8.59144,
    x2: 35.9913,
    y2: 33.4711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3381_78698",
    x1: 12.496,
    y1: 9.90327,
    x2: 34.5113,
    y2: 34.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3381_78698",
    x1: 10.5044,
    y1: 11.666,
    x2: 32.5197,
    y2: 36.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3381_78698",
    x1: 9.68524,
    y1: 12.3892,
    x2: 31.7005,
    y2: 37.2685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3381_78698",
    x1: 8.21568,
    y1: 13.69,
    x2: 30.231,
    y2: 38.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3381_78698",
    x1: 8.29359,
    y1: 13.623,
    x2: 30.3089,
    y2: 38.5023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3381_78698",
    x1: 9.28083,
    y1: 12.75,
    x2: 31.2961,
    y2: 37.6293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3381_78698",
    x1: 13.9807,
    y1: 8.59083,
    x2: 35.996,
    y2: 33.4701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D810FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3953ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeLeave);
export default __webpack_public_path__ + "static/media/employee_leave.31ed07aae014b1de6b495ce5e0808412.svg";
export { ForwardRef as ReactComponent };